import { useMainStore } from "@/core/stores/main-store";
import BaseService from "../base/BaseService";
import IParamServices from "../IParamServices";
import { IServiceResponse } from "@/core/model/rest/IServiceResponse";

export interface IAppUserSettings
{
  profileImg:string,
  theme:string,
  language:string
}
export interface IAppSystemSettings
{
    Id:number|null;
    Setting:string;
    Value:string; 
    Activo:boolean;
}
export default class AppSystemSettingsService extends BaseService
{
  constructor(param: IParamServices)
  {
    super(param);
  }
  public getSettingByName(settingName: string):IAppSystemSettings
  {    
    const appSystemSettings = this.getSettingsFromPinia();
    let setting:IAppSystemSettings|undefined = appSystemSettings.find((x:IAppSystemSettings) => x.Setting === settingName);
    if(!setting)
    {
      setting = {
        Id:0,
        Setting:'',
        Value:'',
        Activo:true
      };
    }      
    return setting;
  }
  protected getSettingsFromPinia():IAppSystemSettings[]
  {
    return useMainStore().getAppSettings;
  }
  public async SaveAppOptions(gid:any,settings:IAppUserSettings):Promise<any>
  {    
    const response:IServiceResponse = await this.Post('IndexEmployee/SaveAppOptions',{
      Gid:gid,
      Photo:settings.profileImg,
      Theme:settings.theme,
      Language:settings.language
    },null,null,null,true,false,null);      
    return response && response.Response? response.Response:null;
  }
}